import { isEmpty } from "lodash-es";
import { useIntl } from "react-intl";
import type { InfinitySelectOption } from "~components/InfinitySelect";
import { SelectPool } from "~components/SelectPool/SelectPool";
import type { Pool } from "~types/pool";
import { useUpdateListFixture } from "../../hooks";
import type { ColumnComponentProperties } from "../../types";

interface IPoolColumnProperties extends ColumnComponentProperties {
  pool: Pool;
}

export const PoolColumn = (properties: IPoolColumnProperties) => {
  const { formatMessage } = useIntl();
  const { mutate: updateFixture, isPending: isLoading } = useUpdateListFixture();

  if (properties.editMode) {
    const value = isEmpty(properties.pool)
      ? null
      : {
          label: properties.pool.nameLocal,
          value: properties.pool.poolCode,
        };

    const onChangeHandler = (poolOption: InfinitySelectOption | null) =>
      updateFixture({
        fixtureId: properties.fixtureId,
        upsertData: {
          poolCode: poolOption?.value ? poolOption?.value : null,
        },
      });

    return (
      <SelectPool
        disabled={isLoading}
        placeholder={formatMessage({
          id: "fixtureListPage.table.column.editMode.pool.placeholder",
        })}
        value={value}
        onChange={onChangeHandler}
      />
    );
  }

  return properties.pool?.nameLocal;
};
